<template>
    <q-layout view="hHh lpR fFf">
        <q-header class="bg-white text-black" style="border-bottom: 1px solid #e0e0e0">
            <q-toolbar style="justify-content: space-between; padding: 0 2vw">
                <div style="height: 7.17vmin; display: flex; align-items: center">
                    <q-icon name="img:/assets/images/icon/ico_back.svg" :onclick="onBack" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                    <div class="header_lesson q-px-sm b1">
                        <b>설정</b>
                    </div>
                </div>
                <div>
                    <q-icon name="img:/assets/images/icon/ico_home.svg" size="1.85vw" :onclick="onHome" style="width: 2.4vw; height: 2.4vw; cursor: pointer" />
                </div>
            </q-toolbar>
        </q-header>
        <!-- <customHeader title="설정" path="learninghome" /> -->
        <q-page-container>
            <q-page style="padding: 30px 80px">
                <!-- 1111 -->
                <div v-if="latestVer && myVer" class="flex align-center + justify-between" style="border-bottom: 1px solid #e0e0e0">
                    <!-- <span class="box txBold50">앱 버전</span> -->
                    <span class="settingsTt30">앱 버전</span>
                    <div style="vertical-align: middle">
                        <span class="settingsTt40" style="vertical-align: middle">최신버전 {{ latestVer }} / 현재 버전 {{ myVer }}</span>
                        <q-btn unelevated no-ripple :onClick="onUpdate" class="roundedBtnOut" style="margin-left: 3.33vmin; margin-right: 1.4vw">
                            <span class="roundedBtnTt30"> 업데이트 하기</span>
                        </q-btn>
                        <!-- <q-btn unelevated outline style="vertical-align: middle" @click="onUpdate" color="gray1" label="업데이트 하기" /> -->
                    </div>
                </div>
                <!-- 2222 -->
                <div class="q-pa-sm flex align-center + justify-between" style="padding: 20px 40px 20px 0; border-bottom: 1px solid #e0e0e0">
                    <span class="settingsTt30">효과음 설정</span>
                    <CusToggle :is-checked="mSound" @onReturn="onSound" />
                    <!-- <q-toggle v-model="mSound" @click="onSound" color="primary" style="transform: scale(2.4, 2.4)" /> -->
                </div>
                <!-- 3333 -->
                <!-- <div class="q-pa-sm flex align-center + justify-between" style="padding: 0px; border-bottom: 1px solid #e0e0e0">
                    <div @click="onPrivate" style="margin: 20px 50px 20px 0; cursor: pointer; display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%">
                        <span class="settingsTt30">개인정보 처리방침</span>
                        <q-btn unelevated>
                            <q-icon name="img:/assets/images/icon/arrow_right.svg" size="2vw" />
                        </q-btn>
                    </div>
                </div> -->
                <!-- 4444 -->
                <!-- <div class="q-pa-sm flex align-center + justify-between" style="padding: 0px; border-bottom: 1px solid #e0e0e0">
                    <div @click="onTerms" style="margin: 20px 50px 20px 0; cursor: pointer; display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%">
                        <span class="settingsTt30">서비스 이용약관</span>
                        <q-btn unelevated @click="onPrivate">
                            <q-icon name="img:/assets/images/icon/arrow_right.svg" size="2vw" />
                        </q-btn>
                    </div> -->
                    <!-- <q-btn unelevated round icon="chevron_right" @click="onTerms" /> -->
                <!-- </div> -->
                <div class="q-pa-sm flex align-center + justify-between" style="padding: 0px; border-bottom: 1px solid #e0e0e0">
                    <div @click="onFAQ" style="margin: 20px 50px 20px 0; cursor: pointer; display: flex; flex-direction: row; align-items: center; justify-content: space-between; width: 100%">
                        <span class="settingsTt30">FAQ</span>
                        <q-btn unelevated @click="onFAQ">
                            <q-icon name="img:/assets/images/icon/arrow_right.svg" size="2vw" />
                        </q-btn>
                    </div>
                    <!-- <q-btn unelevated round icon="chevron_right" /> -->
                </div>
            </q-page>
        </q-page-container>
    </q-layout>
</template>

<script setup>
import { onMounted, ref, watch, computed } from 'vue';
import customHeader from '@/components/layouts/header/header.vue';

import CusToggle from '@/components/widget/CusToggle.vue';
import { getUserInfo, setSoundSwitch, latestAppVersion } from '@/api/modules/mypage.js';

import { useQuasar } from 'quasar';
import { useRouter, useRoute } from 'vue-router';
import { GlobalStore } from '@/store';
import { DialogStore } from '@/store/modules/dialog';
import { monitoringLog } from '@/api/modules/monitoring';

const dStore = DialogStore();
const gStore = GlobalStore();
const router = useRouter();
const route = useRoute();
const $q = useQuasar();

// const isDisablePWBtn = ref(false);
// const isDisableSubmitBtn = ref(true);

const latestVer = ref(null);
const myVer = ref(null);
const mSound = ref(gStore.sound);
const superPass = ref(1);
const superPassRed = ref(null);
const superPassBlue = ref(null);
const superPassRedCheck = ref(false);
const superPassBlueCheck = ref(false);

const setUserData = async () => {
    const res = await getUserInfo(gStore.token);
    // console.log('--info-res-', res);
    if (res)
        if (res.status === 200) mSound.value = res.data.data.soundYn;
        else {
            // if (route.path === '/settings')
            //     dStore.errorMsg(`${res.data.message}`, () => {
            //         router.push('/learninghome');
            //     });
        }
    else {
        // if (route.path === '/settings')
        //     dStore.errorConnection(() => {
        //         router.push('/learninghome');
        //     });
    }
};
const setLatestAppVer = async () => {
    // store.platform = 'ANDROID';
    if (gStore.platform && gStore.platform !== 'DESKTOP') {
        const res = await latestAppVersion(gStore.platform);
        // console.log('--info-res-', res);
        if (res && res.status === 200) {
            latestVer.value = res.data.data;
            myVer.value = gStore.appVersion;
            // console.log('--setLatestAppVer-   latestVer.value-', latestVer.value);
            // console.log('--setLatestAppVer-   myVer.value-', myVer.value);
        }
    }
};
onMounted(() => {
    // console.log('--onMounted-settings-');
    setUserData();
    setLatestAppVer();

    let data = {
        menuName: route.path.split('/').join(''),
    };
    monitoringLog(data, (res) => {
        console.log('settings monitoringLog API response ===', res);
    });
});
////////////////////////////----OnClick----////////////////////////////
const onUpdate = () => {
    // store.errorMsg(`  준비중입니다.`);
    if (gStore.appVersion) {
        try {
            dStore.errorMsg(`스토어 등록이 필요합니다.`);
            if (gStore.platform === 'ANDROID') {
                // console.log('--ANDROID--');
                // 업데이트는 스토어 등록이 선행되어야함
                // window.AndroidBridge.forceUpdate();
            }
            if (gStore.platform === 'IOS') {
                // console.log('--IOS--');
                // 업데이트는 스토어 등록이 선행되어야함
                // window.webkit.messageHandlers?.forceUpdate?.postMessage('version');
            }
        } catch (error) {
            // update error
        }
    } else dStore.errorMsg(`앱에서만 업데이트가 가능합니다.`);
};
const onSound = async (isChecked) => {
  mSound.value = isChecked;
  const response = await setSoundSwitch(gStore.token, mSound.value);
  if (response && response.status === 200) {
    gStore.setSound(mSound.value);
  }
  handleSuperPass();
  superPass.value += 1;
};

const handleSuperPass = () => {
  localStorage.removeItem('videoSuperPass');
  if (superPass.value === 1) {
    superPassRed.value = getRandomInt(30,50);
  } else if (isSuperPassRed()) {
    changeColorAndCallSuperPass('red', 3000);
  } else if (isSuperPassBlue()) {
    changeColorAndCallSuperPass('blue', 3000);
  }
};

const isSuperPassRed = () => {
  return superPassRed.value === superPass.value && !superPassRedCheck.value;
};

const isSuperPassBlue = () => {
  return superPassRedCheck.value && superPassBlue.value === superPass.value && !superPassBlueCheck.value;
};

const changeColorAndCallSuperPass = (color, delay) => {
  document.querySelector('.settingsTt30').style.color = color;
  setTimeout(onSuperPass, delay);
};

const onSuperPass = () => {
  document.querySelector('.settingsTt30').style.color = "black";
  if (!mSound.value && !superPassRedCheck.value) {
    superPassRedCheck.value = true;
    superPassBlue.value = getRandomInt(50,60);
    superPass.value = 49;
  } else if (mSound.value && superPassRedCheck.value) {
    superPassBlueCheck.value = true;
    localStorage.setItem('videoSuperPass', '1');
  }
};

const urlPrivate = 'https://www.macadamia.kr/notice/private-info?_ga=2.163193919.2085028938.1679458899-2055350912.1679458899';
const urlTerms = 'https://www.macadamia.kr/notice/terms?_ga=2.163193919.2085028938.1679458899-2055350912.1679458899';

const onPrivate = () => {
    // const openNewWindow = window.open();
    const openNewWindow = window.open('about:blank');
    openNewWindow.location.href = urlPrivate;
    // gStore.setIsPrivate(true);
    // router.push('/terms');
};
const onTerms = () => {
    const openNewWindow = window.open('about:blank');
    openNewWindow.location.href = urlTerms;
    // gStore.setIsPrivate(false);
    // router.push('/terms');
};

const onFAQ = () => {
    router.push('/faq');
};
const onBack = () => {
    router.push('/mypage');
};
const onHome = () => {
    // router.push('/learninghome');
    dStore.openSelect('홈으로 이동하시겠습니까?', (val) => {
        val && router.push('/learninghome');
    });
};

const getRandomInt = (min, max) => {
  return Math.floor(Math.random() * (Math.floor(max) - Math.ceil(min) + 1)) + Math.ceil(min);
}
</script>

<style lang="scss">
.roundedBtnOut {
    padding: 14px 40px;
    border-radius: 1.3vmin;
    border: 1px solid black;
    background-color: white;
}

.box {
    padding: 20px;
}
/*
.normal {
    width: 100px;
    border: 1px solid black;
    border-radius: 40px;
    background-color: white;
    color: #123;
}
*/
.hit {
    background-color: black;
    color: white;
}
</style>
